export default function () {
    // LIGHTBOX
    const $fancyBox = $('.fancybox');

    if (!$fancyBox.length) {
        return;
    }

    const script = '/typo3conf/ext/udg_package/Resources/Public/JavaScript/fancybox.min.js';
    $.getScript(script).done(() => {
        $('.fancybox').fancybox({
            openEffect: 'none',
            closeEffect: 'none',
            helpers: {
                media: {},
            },
        });
    });
}
